export default "__VITE_ASSET__JllV3Ryo__"